import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'

export type ProductToAdd = {
  productSku: string
  productName: string
  trackingEventCategory: string
}

export const productToAddFavoriteListDrawerAtom = atom<ProductToAdd | null>()

export const resettableAddProductToFavoriteListDrawerAtom = atomWithReset(
  productToAddFavoriteListDrawerAtom,
)
